import axios from '../../externals/axios';
import { assign } from '../utils';
export default (function (create) {
    var RequestStatic = assign(axios, {
        create: create,
    });
    return RequestStatic;
});
//# sourceMappingURL=createRequestStatic.js.map